import { styled } from '@mui/material'
import { FC } from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'

// others
import { formatBillEntriesByDate } from '../../../utils/billing'
import { formatCurrency } from '../../../utils'
import { InfoOutlined } from '@mui/icons-material'
import { BillItem } from '../../../interfaceTypes/billing'
import { BillingType } from '../../../../generated'

interface BillPreviewEntriesTableProps {
  billItems: BillItem[]
  billingType: BillingType | undefined
}

const CustomTable = styled(Table)(({ theme }) => ({
  minWidth: '600px',
  border: '1px solid #E0E0E0',
  '& .MuiTableCell-root': {
    padding: theme.spacing(1),
    fontSize: '10px !important',
    backgroundColor: 'transparent'
  }
}))

const BillPreviewEntriesTable: FC<BillPreviewEntriesTableProps> = ({ billItems, billingType }) => {
  const rows = formatBillEntriesByDate(billItems)

  return (
    <CustomTable>
      <TableHead>
        <TableRow>
          <TableCell width="12%">Date</TableCell>
          <TableCell width="8%">Type</TableCell>
          <TableCell width="33%">Notes</TableCell>
          <TableCell width="16%">Atty / Support</TableCell>
          <TableCell width="7%">Duration</TableCell>
          <TableCell width="12%">Amount</TableCell>
          <TableCell width="12%">Total</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {rows.map(row => {
          const { id, date, type, notes, attorney, duration, rate, total, isBillable } = row

          return (
            <TableRow
              key={id}
              sx={{
                backgroundColor: !isBillable ? '#26A69A4D' : 'transparent'
              }}
            >
              <TableCell>{date}</TableCell>

              <TableCell>{type}</TableCell>
              <TableCell sx={{ whiteSpace: 'pre-line' }}>
                {notes}
                {!isBillable && (
                  <Typography color="primary.main" fontSize="10px" display="flex" alignItems="center" gap={0.4}>
                    <InfoOutlined fontSize="inherit" />
                    {billingType === BillingType.Hybrid ? 'Applied towards your available balance' : 'Accommodated'}
                  </Typography>
                )}
              </TableCell>
              <TableCell>{attorney}</TableCell>
              <TableCell>{duration}</TableCell>
              <TableCell>{formatCurrency(rate)}</TableCell>
              <TableCell sx={{ textDecoration: !isBillable ? 'line-through' : 'none' }}>
                {formatCurrency(total)}
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </CustomTable>
  )
}

export default BillPreviewEntriesTable
